import React from "react";
import { useRouter } from "../../../hooks/useRouter";

import { useStore } from "../../../context/state";

import { PrivacyPolicyContent } from "../../../components/PrivacyPolicyContent";

import { addParamToQueryString } from "commons-ui/core/utils";

export const Content = () => {
  const { dispatch } = useStore();

  const location = useRouter();

  return (
    <div className="">
      <div className="u-flexCenter u-justifyContentCenter">
        <div className="u-maxWidth600">
          <PrivacyPolicyContent
            onTermsAndConditions={() =>
              dispatch(
                addParamToQueryString("license_agreement", "true", location)
              )
            }
          />
        </div>
      </div>
    </div>
  );
};
